<template>
  <div class="page-card">
    <el-card>
      <div slot="header">商家管理</div>
      <el-form :inline="true" size="small" @submit.native.prevent>
        <el-form-item label="商家名称">
          <el-input v-model="query.name" placeholder="商家名称" />
        </el-form-item>
        <el-form-item label="类型">
          <el-input v-model="query.type" placeholder="类型，如餐饮、酒店" />
        </el-form-item>
        <el-form-item label="排序">
          <el-select v-model="query.sort" placeholder="默认" style="width: 140px;" clearable>
            <el-option label="默认（推荐权重）" value="default" />
            <el-option label="点击量" value="click" />
            <el-option label="导航量" value="navigate" />
            <el-option label="核销量" value="coupon_use" />
            <el-option label="评分" value="rating" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="fetchList">查询</el-button>
          <el-button @click="resetQuery">重置</el-button>
          <el-button type="success" @click="openEdit()">新增商家</el-button>
        </el-form-item>
      </el-form>

      <el-table :data="list" border stripe>
        <el-table-column prop="id" label="ID" width="70" />
        <el-table-column prop="name" label="名称" />
        <el-table-column prop="type" label="类型" />
        <el-table-column prop="subCategory" label="细分分类" width="110" />
        <el-table-column label="公司经营" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.isCompanyBusiness ? 'success' : 'info'">
              {{ scope.row.isCompanyBusiness ? '是' : '否' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="checkinCategory" label="宝藏星球分类" width="120" />
        <el-table-column prop="address" label="地址" />
      <el-table-column prop="phone" label="联系方式" width="120" />
      <el-table-column prop="avgPrice" label="人均消费" width="100" />
        <el-table-column prop="rating" label="评分" width="80" />
        <el-table-column prop="clickCount" label="点击量" width="90" />
        <el-table-column prop="navigateCount" label="导航量" width="90" />
        <el-table-column prop="couponUseCount" label="券核销量" width="100" />
        <el-table-column prop="sortWeight" label="推荐权重" width="100" />
        <el-table-column label="小程序展示" width="110" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status !== false ? 'success' : 'info'" size="small">
              {{ scope.row.status !== false ? '上架' : '下架' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="320">
          <template slot-scope="scope">
            <el-button size="mini" @click="openEdit(scope.row)">编辑</el-button>
            <el-button
              v-if="scope.row.status !== false"
              size="mini"
              type="warning"
              @click="setMerchantShelf(scope.row, false)"
            >下架</el-button>
            <el-button
              v-else
              size="mini"
              type="success"
              @click="setMerchantShelf(scope.row, true)"
            >上架</el-button>
            <el-button size="mini" type="danger" @click="remove(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div style="text-align:right;margin-top:16px;">
        <el-pagination
          layout="prev, pager, next, total"
          :total="total"
          :page-size="query.pageSize"
          :current-page.sync="query.page"
          @current-change="fetchList"
        />
      </div>

      <el-dialog
        :title="editForm.id ? '编辑商家' : '新增商家'"
        :visible.sync="editVisible"
        width="800px"
      >
        <el-form :model="editForm" :rules="editRules" ref="editForm" label-width="90px">
          <el-form-item label="名称" prop="name">
            <el-input v-model="editForm.name" placeholder="请输入商家名称" />
          </el-form-item>
          <el-form-item label="类型" prop="type">
            <el-select
              v-model="editForm.type"
              placeholder="请选择商家类型"
              style="width: 100%;"
              @change="handleTypeChange"
            >
              <el-option label="餐饮" value="餐饮" />
              <el-option label="酒店" value="酒店" />
              <el-option label="景区" value="景区" />
              <el-option label="ETC服务" value="ETC服务" />
              <el-option label="充电站" value="充电站" />
              <el-option label="生活服务" value="生活服务" />
              <el-option label="伴手礼" value="伴手礼" />
              <el-option label="网红打卡点" value="网红打卡点" />
            </el-select>
          </el-form-item>
          <el-form-item
            v-if="merchantSubCategoryOptions.length"
            label="细分分类"
            prop="subCategory"
          >
            <el-select
              v-model="editForm.subCategory"
              placeholder="请选择细分分类"
              style="width: 100%;"
              clearable
            >
              <el-option
                v-for="o in subCategorySelectOptions"
                :key="o"
                :label="o"
                :value="o"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="地址" prop="address">
            <el-input v-model="editForm.address" placeholder="选点后逆解析可自动填入；也可手改">
              <el-button slot="append" icon="el-icon-location-outline" @click="openMap">地图选点</el-button>
            </el-input>
          </el-form-item>
          <el-form-item label="门店坐标" prop="latitude">
            <div class="merchant-coords-row">
              <span :class="['merchant-coords-text', { 'is-placeholder': !hasValidMerchantCoords }]">
                {{ merchantCoordsSummary }}
              </span>
              <!-- <el-button type="primary" plain size="small" icon="el-icon-location-outline" @click="openMap">
                地图选点
              </el-button> -->
            </div>
          </el-form-item>
          <el-form-item label="公司经营">
            <el-switch v-model="editForm.isCompanyBusiness" active-text="是" inactive-text="否" />
          </el-form-item>
          <el-form-item v-if="editForm.type === '网红打卡点'" label="星球分类" prop="checkinCategory">
            <el-select v-model="editForm.checkinCategory" placeholder="请选择宝藏星球分类" style="width: 100%;">
              <el-option label="红色教育" value="红色教育" />
              <el-option label="人文历史" value="人文历史" />
              <el-option label="自然风光" value="自然风光" />
              <el-option label="宝藏小店" value="宝藏小店" />
            </el-select>
          </el-form-item>
          <el-form-item label="联系方式" prop="phone">
            <el-input v-model="editForm.phone" placeholder="请输入联系电话" />
          </el-form-item>
          <el-form-item label="营业时间" prop="businessHours">
            <el-input v-model="editForm.businessHours" placeholder="如：09:00-21:00" />
          </el-form-item>
          <el-form-item label="人均消费" prop="avgPrice">
            <el-input-number v-model="editForm.avgPrice" :min="0" :max="999999" />
          </el-form-item>
          <el-form-item label="评分" prop="rating">
            <el-input-number
              v-model="editForm.rating"
              :min="0"
              :max="5"
              :step="0.1"
              :precision="1"
              placeholder="0～5 星"
            />
          </el-form-item>
          <el-form-item label="商家图片" prop="image">
            <el-upload
              :key="uploadKey"
              class="avatar-uploader"
              action=""
              list-type="picture-card"
              multiple
              :file-list="imageFileList"
              :http-request="uploadMerchantImage"
              :before-upload="beforeImageUpload"
              :on-remove="handleImageRemove"
            >
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="简介" prop="description">
            <el-input type="textarea" v-model="editForm.description" placeholder="可填写网红打卡点、伴手礼等介绍" />
          </el-form-item>
          <el-form-item label="优惠信息" prop="promoInfo">
            <el-input type="textarea" v-model="editForm.promoInfo" placeholder="如：满100减10、人均消费等" />
          </el-form-item>
          <el-form-item label="推荐权重">
            <el-input-number v-model="editForm.sortWeight" :min="0" :max="9999" />
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="editVisible = false">取 消</el-button>
          <el-button type="primary" @click="saveMerchant">保 存</el-button>
        </span>
      </el-dialog>

      <el-dialog
        title="选择门店位置"
        :visible.sync="mapDialogVisible"
        width="800px"
        top="5vh"
        @closed="onMapDialogClosed"
      >
        <div v-if="mapDialogVisible" class="map-picker-info">
          <div class="map-picker-info-row">
            <span class="map-picker-info-label">经纬度</span>
            <span class="map-picker-info-value">{{ mapPickerCoordsText }}</span>
          </div>
          <div class="map-picker-info-row map-picker-info-row--address">
            <span class="map-picker-info-label">地址预览</span>
            <span class="map-picker-info-value">{{ mapPickerAddressLine || '打开时为表单地址；点击地图或搜索选点后将尝试逆解析更新' }}</span>
          </div>
        </div>
        <div v-if="mapDialogVisible" class="map-picker-toolbar">
          <el-autocomplete
            v-model="mapPickerSearchKeyword"
            class="map-picker-search-input"
            :fetch-suggestions="fetchMapPlaceSuggestions"
            placeholder="搜索地点（输入关键词，在下拉结果中选择）"
            :trigger-on-focus="false"
            clearable
            highlight-first-item
            popper-class="map-picker-search-popper"
            @select="onMapPlaceSelect"
          />
          <el-button
            type="primary"
            plain
            icon="el-icon-aim"
            :loading="mapPickerLocating"
            @click="onMapPickerLocateMe"
          >
            选中当前位置
          </el-button>
        </div>
        <div
          v-if="mapDialogVisible"
          v-loading="mapPickerWrapLoading"
          :element-loading-text="mapPickerWrapLoadingText"
          class="map-picker-wrap"
        >
          <tlbs-map
            :api-key="tencentMapKey"
            :center="mapPickerCenter"
            :zoom="mapPickerZoom"
            :control="mapPickerControl"
            @map_inited="onMapPickerInited"
          >
            <tlbs-multi-marker
              :geometries="mapPickerMarkerGeometries"
              :styles="mapPickerMarkerStyles"
            />
          </tlbs-map>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="mapDialogVisible = false">完 成</el-button>
          <el-button @click="mapDialogVisible = false">取 消</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import request, {
  resolveUploadedFileUrl,
  pickUploadResponsePayload,
  normalizeMediaUrl
} from '@/api/request'

export default {
  name: 'MerchantList',
  data() {
    return {
      query: {
        name: '',
        type: '',
        sort: 'default',
        page: 1,
        pageSize: 10
      },
      list: [],
      total: 0,
      editVisible: false,
      uploadKey: 0,
      editForm: {
        id: null,
        name: '',
        type: '',
        checkinCategory: '',
        subCategory: '',
        address: '',
        description: '',
        promoInfo: '',
        businessHours: '',
        sortWeight: 0,
        image: '',
        images: [],
        latitude: '',
        longitude: '',
        phone: '',
        avgPrice: 0,
        rating: 0,
        isCompanyBusiness: false
      },
      imageFileList: [],
      mapDialogVisible: false,
      mapGeocodeLoading: false,
      mapPickerLocating: false,
      mapPickerSearchKeyword: '',
      mapPickerAddressLine: '',
      _mapSuggestTimer: null,
      tencentMapKey: process.env.VUE_APP_TENCENT_MAP_KEY || '',
      tencentWebServiceKey:
        process.env.VUE_APP_TENCENT_MAP_WEB_KEY ||
        process.env.VUE_APP_TENCENT_MAP_WEB_SERVICE_KEY ||
        process.env.VUE_APP_TENCENT_MAP_KEY ||
        '',
      mapPickerCenter: { lat: 39.908823, lng: 116.39747 },
      mapPickerZoom: 16,
      mapPickerMarkerGeometries: [],
      mapPickerMarkerStyles: {
        pick: {
          width: 25,
          height: 35,
          anchor: { x: 12.5, y: 35 },
          src: 'https://mapapi.qq.com/web/miniprogram/demoCenter/images/marker.png'
        }
      },
      mapPickerControl: {
        zoom: { position: 'topRight' },
        scale: {},
        rotation: false
      },
      editRules: {
        name: [{ required: true, message: '请输入商家名称', trigger: 'blur' }],
        type: [{ required: true, message: '请选择商家类型', trigger: 'change' }],
        checkinCategory: [
          {
            validator: (rule, value, callback) => {
              if (this.editForm.type === '网红打卡点' && !value) {
                callback(new Error('请选择宝藏星球分类'))
              } else {
                callback()
              }
            },
            trigger: 'change'
          }
        ],
        address: [{ required: true, message: '请输入地址', trigger: 'blur' }],
        phone: [{ required: true, message: '请输入联系方式', trigger: 'blur' }],
        avgPrice: [
          {
            validator: (rule, value, callback) => {
              if (!value || Number(value) <= 0) {
                callback(new Error('请输入大于 0 的人均消费'))
              } else {
                callback()
              }
            },
            trigger: 'change'
          }
        ],
        description: [{ required: true, message: '请输入简介', trigger: 'blur' }],
        promoInfo: [{ required: true, message: '请输入优惠信息', trigger: 'blur' }],
        image: [
          {
            required: true,
            validator: (rule, value, callback) => {
              const hasList = this.imageFileList && this.imageFileList.length > 0
              const hasImage = this.editForm.image
              if (hasList || hasImage) {
                callback()
              } else {
                callback(new Error('请至少上传一张商家图片'))
              }
            },
            trigger: 'change'
          }
        ],
        latitude: [
          {
            validator: (rule, value, callback) => {
              const lat = parseFloat(String(this.editForm.latitude || '').trim())
              const lng = parseFloat(String(this.editForm.longitude || '').trim())
              const ok =
                Number.isFinite(lat) &&
                Number.isFinite(lng) &&
                Math.abs(lat) >= 1e-5 &&
                Math.abs(lng) >= 1e-5 &&
                lat >= -90 &&
                lat <= 90 &&
                lng >= -180 &&
                lng <= 180
              if (ok) {
                callback()
              } else {
                callback(new Error('请通过「地图选点」选择有效门店位置，经纬度不能为空'))
              }
            },
            trigger: ['change', 'blur']
          }
        ]
      }
    }
  },
  computed: {
    merchantSubCategoryOptions() {
      const map = {
        餐饮: ['中餐', '西餐', '快餐', '小吃', '饮品'],
        酒店: ['经济型', '舒适型', '高档型', '豪华型', '民宿'],
        景区: ['红色教育', '人文历史', '自然风光'],
        生活服务: ['卫生院', '修理厂', '便利店', '加油站'],
        充电站: ['空闲', '快充', '满充']
      }
      return map[this.editForm.type] || []
    },
    subCategorySelectOptions() {
      const opts = [...this.merchantSubCategoryOptions]
      const cur = this.editForm.subCategory
      if (cur && opts.indexOf(cur) < 0) opts.unshift(cur)
      return opts
    },
    mapPickerCoordsText() {
      const lat = String(this.editForm.latitude || '').trim()
      const lng = String(this.editForm.longitude || '').trim()
      if (!lat || !lng) return '—'
      return `${lng}, ${lat}`
    },
    mapPickerWrapLoading() {
      return this.mapGeocodeLoading || this.mapPickerLocating
    },
    mapPickerWrapLoadingText() {
      if (this.mapGeocodeLoading) return '正在解析地址…'
      if (this.mapPickerLocating) return '正在获取当前位置…'
      return '加载中…'
    },
    hasValidMerchantCoords() {
      const lat = parseFloat(String(this.editForm.latitude || '').trim())
      const lng = parseFloat(String(this.editForm.longitude || '').trim())
      return (
        Number.isFinite(lat) &&
        Number.isFinite(lng) &&
        Math.abs(lat) >= 1e-5 &&
        Math.abs(lng) >= 1e-5 &&
        lat >= -90 &&
        lat <= 90 &&
        lng >= -180 &&
        lng <= 180
      )
    },
    merchantCoordsSummary() {
      if (!this.hasValidMerchantCoords) return '未选择，请点击「地图选点」'
      return `${this.editForm.longitude}, ${this.editForm.latitude}`
    }
  },
  created() {
    this.fetchList()
  },
  beforeDestroy() {
    this.teardownMapPickerListeners()
  },
  methods: {
    handleTypeChange(v) {
      if (v !== '网红打卡点') {
        this.editForm.checkinCategory = ''
      }
      this.editForm.subCategory = ''
    },
    fetchList() {
      request.get('/merchants', { params: this.query }).then(res => {
        const data = res.data || res
        this.list = (data && data.items) || []
        this.total = (data && data.total) || 0
      })
    },
    openMap() {
      if (!this.tencentMapKey) {
        this.$message.warning('未配置腾讯地图 Key，请先设置 VUE_APP_TENCENT_MAP_KEY')
        return
      }
      this.mapGeocodeLoading = false
      this.mapPickerLocating = false
      this.mapPickerAddressLine = (this.editForm.address || '').trim()
      const lat = parseFloat(String(this.editForm.latitude || '').trim())
      const lng = parseFloat(String(this.editForm.longitude || '').trim())
      if (!Number.isNaN(lat) && !Number.isNaN(lng)) {
        this.mapPickerCenter = { lat, lng }
        this.mapPickerMarkerGeometries = [
          { id: 'merchant-pick', styleId: 'pick', position: { lat, lng } }
        ]
      } else {
        this.mapPickerCenter = { lat: 39.908823, lng: 116.39747 }
        this.mapPickerMarkerGeometries = []
      }
      this.mapPickerZoom = 16
      this.mapDialogVisible = true
      this.$nextTick(() => {
        this.applyCurrentLocationAsMapCenter()
      })
    },
    applyCurrentLocationAsMapCenter() {
      if (!navigator.geolocation) {
        return
      }
      this.mapPickerLocating = true
      navigator.geolocation.getCurrentPosition(
        pos => {
          this.mapPickerLocating = false
          if (!this.mapDialogVisible) return
          const lat = pos.coords.latitude
          const lng = pos.coords.longitude
          if (Number.isNaN(lat) || Number.isNaN(lng)) return
          this.mapPickerCenter = { lat, lng }
          this.mapPickerZoom = 16
        },
        () => {
          this.mapPickerLocating = false
          if (!this.mapDialogVisible) return
          this.$message.info('未获取到当前位置，地图以已保存坐标或默认区域为中心')
        },
        { enableHighAccuracy: false, timeout: 12000, maximumAge: 60000 }
      )
    },
    /** 地图选点：写入经纬度、标记、可选逆解析 */
    setMapPickerFromLatLng(latNum, lngNum, withGeocode) {
      if (Number.isNaN(latNum) || Number.isNaN(lngNum)) return
      this.editForm.latitude = latNum.toFixed(6)
      this.editForm.longitude = lngNum.toFixed(6)
      this.mapPickerMarkerGeometries = [
        { id: 'merchant-pick', styleId: 'pick', position: { lat: latNum, lng: lngNum } }
      ]
      this.mapPickerCenter = { lat: latNum, lng: lngNum }
      if (withGeocode) this.fillAddressByLocation(latNum, lngNum)
      this.$nextTick(() => {
        if (this.$refs.editForm) this.$refs.editForm.validateField('latitude')
      })
    },
    onMapPickerLocateMe() {
      if (!navigator.geolocation) {
        this.$message.warning('当前浏览器不支持定位')
        return
      }
      this.mapPickerLocating = true
      navigator.geolocation.getCurrentPosition(
        pos => {
          this.mapPickerLocating = false
          if (!this.mapDialogVisible) return
          const lat = pos.coords.latitude
          const lng = pos.coords.longitude
          if (Number.isNaN(lat) || Number.isNaN(lng)) return
          this.mapPickerZoom = 17
          this.setMapPickerFromLatLng(lat, lng, true)
          this.$message.success('已选中当前位置')
        },
        () => {
          this.mapPickerLocating = false
          if (!this.mapDialogVisible) return
          this.$message.warning('获取定位失败，请允许浏览器位置权限后重试')
        },
        { enableHighAccuracy: true, timeout: 15000, maximumAge: 0 }
      )
    },
    onMapPickerInited(map) {
      this.teardownMapPickerListeners()
      const handler = evt => {
        const ll = evt && evt.latLng
        if (!ll) return
        const rawLat = typeof ll.getLat === 'function' ? ll.getLat() : ll.lat
        const rawLng = typeof ll.getLng === 'function' ? ll.getLng() : ll.lng
        const latNum = Number(rawLat)
        const lngNum = Number(rawLng)
        this.setMapPickerFromLatLng(latNum, lngNum, true)
      }
      map.on('click', handler)
      this._mapPickerUnbind = () => {
        try {
          map.off('click', handler)
        } catch (e) {
          /* ignore */
        }
      }
    },
    onMapDialogClosed() {
      this.teardownMapPickerListeners()
      this.mapPickerAddressLine = ''
      this.mapPickerLocating = false
      this.mapPickerSearchKeyword = ''
      if (this._mapSuggestTimer) {
        clearTimeout(this._mapSuggestTimer)
        this._mapSuggestTimer = null
      }
    },
    teardownMapPickerListeners() {
      if (typeof this._mapPickerUnbind === 'function') {
        this._mapPickerUnbind()
        this._mapPickerUnbind = null
      }
    },
    /**
     * 腾讯 WebService JSONP（逆解析、地点提示等共用）
     */
    tencentWebServiceJsonp(urlPath, params) {
      const key = (this.tencentWebServiceKey || '').trim()
      if (!key) return Promise.reject(new Error('no key'))
      return new Promise((resolve, reject) => {
        const cb = `__tencentWs_${Date.now()}_${Math.floor(Math.random() * 1e6)}`
        let script = null
        let timer = null
        let settled = false
        const done = (fn, arg) => {
          if (settled) return
          settled = true
          if (timer) clearTimeout(timer)
          timer = null
          if (script && script.parentNode) script.parentNode.removeChild(script)
          script = null
          try {
            delete window[cb]
          } catch (e) {
            window[cb] = undefined
          }
          fn(arg)
        }
        timer = setTimeout(() => {
          done(reject, new Error('timeout'))
        }, 15000)
        window[cb] = data => {
          done(resolve, data)
        }
        script = document.createElement('script')
        script.onerror = () => done(reject, new Error('jsonp load failed'))
        const q = new URLSearchParams({
          ...params,
          key,
          output: 'jsonp',
          callback: cb
        })
        const sep = urlPath.includes('?') ? '&' : '?'
        script.src = `${urlPath}${sep}${q.toString()}`
        document.body.appendChild(script)
      })
    },
    reverseGeocodeJsonp(lat, lng) {
      const location = `${lat},${lng}`
      return this.tencentWebServiceJsonp('https://apis.map.qq.com/ws/geocoder/v1/', {
        location,
        get_poi: '0'
      })
    },
    placeSuggestionJsonp(keyword) {
      const k = (keyword || '').trim()
      if (!k) return Promise.reject(new Error('empty keyword'))
      const params = {
        keyword: k,
        page_size: '15',
        page_index: '1'
      }
      const c = this.mapPickerCenter
      if (c && typeof c.lat === 'number' && typeof c.lng === 'number') {
        if (!Number.isNaN(c.lat) && !Number.isNaN(c.lng)) {
          params.location = `${c.lat},${c.lng}`
        }
      }
      return this.tencentWebServiceJsonp('https://apis.map.qq.com/ws/place/v1/suggestion', params)
    },
    fetchMapPlaceSuggestions(queryString, cb) {
      const webKey = (this.tencentWebServiceKey || '').trim()
      if (!webKey) {
        cb([])
        return
      }
      const q = (queryString || '').trim()
      if (q.length < 2) {
        cb([])
        return
      }
      if (this._mapSuggestTimer) clearTimeout(this._mapSuggestTimer)
      this._mapSuggestTimer = setTimeout(() => {
        this._mapSuggestTimer = null
        this.placeSuggestionJsonp(q)
          .then(data => {
            if (!data || data.status !== 0 || !Array.isArray(data.data)) {
              cb([])
              return
            }
            const list = data.data
              .map(item => {
                const loc = item.location || {}
                const lat = Number(loc.lat)
                const lng = Number(loc.lng)
                if (Number.isNaN(lat) || Number.isNaN(lng)) return null
                const title = item.title || ''
                const addr = item.address || ''
                const value = addr ? `${title} — ${addr}` : title
                const addrLine = [item.province, item.city, item.district, addr].filter(Boolean).join('')
                return {
                  value,
                  lat,
                  lng,
                  title,
                  address: addr,
                  addrLine: addrLine || value
                }
              })
              .filter(Boolean)
            cb(list)
          })
          .catch(() => cb([]))
      }, 350)
    },
    onMapPlaceSelect(item) {
      if (!item || item.lat == null || item.lng == null) return
      const latNum = Number(item.lat)
      const lngNum = Number(item.lng)
      if (Number.isNaN(latNum) || Number.isNaN(lngNum)) return
      this.editForm.latitude = latNum.toFixed(6)
      this.editForm.longitude = lngNum.toFixed(6)
      this.mapPickerCenter = { lat: latNum, lng: lngNum }
      this.mapPickerZoom = 17
      this.mapPickerMarkerGeometries = [
        { id: 'merchant-pick', styleId: 'pick', position: { lat: latNum, lng: lngNum } }
      ]
      const line = item.addrLine || item.value || ''
      if (line) {
        this.editForm.address = line
        this.mapPickerAddressLine = line
      }
      this.$message.success('已定位到所选地点')
      this.$nextTick(() => {
        if (this.$refs.editForm) this.$refs.editForm.validateField('latitude')
      })
    },
    formatGeocoderAddress(result) {
      if (!result || typeof result !== 'object') return ''
      const fa = result.formatted_addresses || {}
      const line = result.address
      return String(line).trim()
    },
    fillAddressByLocation(lat, lng) {
      const webKey = (this.tencentWebServiceKey || '').trim()
      if (!webKey) {
        this.mapPickerAddressLine =
          '未配置 WebService Key（.env 中 VUE_APP_TENCENT_MAP_WEB_KEY 或 VUE_APP_TENCENT_MAP_WEB_SERVICE_KEY），已保留坐标，请手改地址'
        this.$message.warning('未配置逆解析 Key，经纬度已更新，请手动核对地址')
        return
      }
      this.mapPickerAddressLine = '正在解析地址…'
      this.mapGeocodeLoading = true
      this.reverseGeocodeJsonp(lat, lng)
        .then(data => {
          if (!data || data.status !== 0) {
            const msg = (data && data.message) || '逆地址解析失败'
            this.mapPickerAddressLine = `解析失败：${msg}`
            this.$message.warning(`${msg}，请手动填写地址`)
            return
          }
          const addr = this.formatGeocoderAddress(data.result)
          if (addr) {
            this.editForm.address = addr
            this.mapPickerAddressLine = addr
          } else {
            this.mapPickerAddressLine = '未返回地址文本，请手动填写地址栏'
          }
          this.$message.success(addr ? '已更新位置与地址' : '已更新经纬度')
        })
        .catch(() => {
          this.mapPickerAddressLine = '逆解析请求失败，请手动填写地址'
          this.$message.warning('逆地址解析请求失败，请手动填写地址')
        })
        .finally(() => {
          this.mapGeocodeLoading = false
        })
    },
    resetQuery() {
      this.query.name = ''
      this.query.type = ''
      this.query.sort = 'default'
      this.query.page = 1
      this.fetchList()
    },
    setMerchantShelf(row, on) {
      if (!row || !row.id) return
      const tip = on
        ? '确认上架？上架后小程序将展示该商家。'
        : '确认下架？下架后小程序将不再展示该商家。'
      this.$confirm(tip, '提示', { type: 'warning' })
        .then(() =>
          request.put(`/merchants/${row.id}`, { status: on }).then(() => {
            this.$message.success(on ? '已上架' : '已下架')
            this.fetchList()
          })
        )
        .catch(() => {})
    },
    openEdit(row) {
      if (row && row.id) {
        request.get(`/merchants/${row.id}`).then(res => {
          const data = (res.data || res) || {}
          const imagesRaw = Array.isArray(data.images)
            ? data.images
            : (data.image ? [data.image] : [])
          const images = imagesRaw.map(u => normalizeMediaUrl(u) || u)
          const img = images[0] || ''
          this.editForm = {
            id: data.id,
            name: data.name || '',
            type: data.type || '',
            checkinCategory: data.checkinCategory || '',
            subCategory: data.subCategory || '',
            address: data.address || '',
            description: data.description || '',
            promoInfo: data.promoInfo || '',
            businessHours: data.businessHours || '',
            sortWeight: data.sortWeight != null ? data.sortWeight : 0,
            image: img,
            images,
            latitude: data.latitude || '',
            longitude: data.longitude || '',
            phone: data.phone || '',
            avgPrice: data.avgPrice != null ? data.avgPrice : 0,
            rating: data.rating != null ? Number(data.rating) : 0,
            isCompanyBusiness: !!data.isCompanyBusiness
          }
          this.imageFileList = images.map((u, i) => ({ name: `image_${i + 1}`, url: u }))
          this.uploadKey += 1
          this.editVisible = true
        }).catch(() => {
          this.$message.error('获取商家详情失败')
        })
        return
      }
      if (!row) {
        this.editForm = {
          id: null,
          name: '',
          type: '',
          checkinCategory: '',
          subCategory: '',
          address: '',
          description: '',
          promoInfo: '',
          businessHours: '',
          sortWeight: 0,
          image: '',
          images: [],
          latitude: '',
          longitude: '',
          phone: '',
          avgPrice: 0,
          rating: 0,
          isCompanyBusiness: false
        }
        this.imageFileList = []
      }
      this.uploadKey += 1
      this.editVisible = true
    },
    saveMerchant() {
      this.$refs.editForm.validate(valid => {
        if (!valid) return
        const data = { ...this.editForm }
        if (data.type !== '网红打卡点') {
          data.checkinCategory = ''
        }
        if (!this.merchantSubCategoryOptions.length) {
          data.subCategory = ''
        }
        // 兼容：后端以 images 为准，同时保留 image=第一张
        data.images = (this.editForm.images && this.editForm.images.length)
          ? this.editForm.images
          : (this.editForm.image ? [this.editForm.image] : [])
        data.image = data.images[0] || ''
        const req = data.id
          ? request.put(`/merchants/${data.id}`, data)
          : request.post('/merchants', data)
        req.then(() => {
          this.$message.success('保存成功')
          this.editVisible = false
          this.fetchList()
        })
      })
    },
    handleImageRemove(file, fileList) {
      this.imageFileList = fileList
      const urls = (fileList || []).map(x => x.url).filter(Boolean)
      this.editForm.images = urls
      this.editForm.image = urls.length ? urls[0] : ''
    },
    beforeImageUpload(file) {
      const isImage = /^image\//.test(file.type || '')
      const okType = ['image/png', 'image/jpeg', 'image/jpg', 'image/webp', 'image/gif'].includes(file.type)
      if (!isImage || !okType) {
        this.$message.error('仅支持 png/jpg/jpeg/webp/gif 格式')
        return false
      }
      const maxMB = 5
      if (file.size / 1024 / 1024 > maxMB) {
        this.$message.error(`图片大小不能超过 ${maxMB}MB`)
        return false
      }
      return true
    },
    uploadMerchantImage(req) {
      const form = new FormData()
      form.append('file', req.file)
      request.post('/upload', form, {
        headers: { 'Content-Type': 'multipart/form-data' }
      }).then(res => {
        const data = pickUploadResponsePayload(res)
        const url = resolveUploadedFileUrl(data)
        if (!url) throw new Error('empty url')
        const next = [...(this.imageFileList || []), { name: req.file.name || 'image', url }]
        this.imageFileList = next
        const urls = next.map(x => x.url).filter(Boolean)
        this.editForm.images = urls
        this.editForm.image = urls[0] || ''
        req.onSuccess && req.onSuccess({ url })
      }).catch(err => {
        this.$message.error('图片上传失败')
        req.onError && req.onError(err)
      })
    },
    useCurrentLocation() {
      if (!navigator.geolocation) {
        this.$message.error('当前浏览器不支持定位')
        return
      }
      navigator.geolocation.getCurrentPosition(
        pos => {
          const { latitude, longitude } = pos.coords
          this.editForm.latitude = latitude.toFixed(6)
          this.editForm.longitude = longitude.toFixed(6)
          this.$message.success('已获取当前位置')
          this.$nextTick(() => {
            if (this.$refs.editForm) this.$refs.editForm.validateField('latitude')
          })
        },
        () => {
          this.$message.error('获取定位失败，请检查浏览器权限')
        }
      )
    },
    remove(row) {
      this.$confirm('确认删除该商家吗？', '提示', { type: 'warning' }).then(() => {
        request.delete(`/merchants/${row.id}`).then(() => {
          this.$message.success('删除成功')
          this.fetchList()
        })
      })
    }
  }
}
</script>

<style scoped>
.map-picker-info {
  padding: 10px 12px;
  margin-bottom: 4px;
  background: #f5f7fa;
  border-radius: 4px;
  border: 1px solid #ebeef5;
  font-size: 13px;
  line-height: 1.5;
}
.map-picker-info-row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}
.map-picker-info-row + .map-picker-info-row {
  margin-top: 8px;
}
.map-picker-info-label {
  flex-shrink: 0;
  width: 72px;
  color: #909399;
}
.map-picker-info-value {
  flex: 1;
  color: #303133;
  word-break: break-all;
}
.map-picker-info-row--address .map-picker-info-value {
  color: #606266;
}
.map-picker-toolbar {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
  margin-bottom: 8px;
}
.map-picker-search-input {
  flex: 1;
  min-width: 0;
}
.map-picker-wrap {
  width: 100%;
  height: 500px;
  margin-top: 0;
}
.map-tip {
  font-size: 13px;
  line-height: 1.55;
  color: #606266;
}
.map-tip p {
  margin: 0 0 8px;
}
.map-tip p:last-child {
  margin-bottom: 0;
}
.map-tip code {
  padding: 0 4px;
  background: #f4f4f5;
  border-radius: 2px;
  font-size: 12px;
}
.merchant-coords-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
}
.merchant-coords-text {
  font-size: 14px;
  color: #303133;
  word-break: break-all;
}
.merchant-coords-text.is-placeholder {
  color: #909399;
}
.merchant-coords-hint {
  margin: 6px 0 0;
  font-size: 12px;
  line-height: 1.5;
  color: #909399;
}
.map-picker-footnote {
  margin: 8px 0 0;
  font-size: 12px;
  line-height: 1.45;
  color: #909399;
}
</style>

<style>
/* 下拉挂载在 body，需非 scoped */
.map-picker-search-popper {
  min-width: 520px;
  max-width: min(760px, 92vw);
}
</style>
